import Main from './MainPage';

export default Main;
